import { apiInstancePublic } from "../../utils";

interface Response {
  token: string;
}

export const ssoCallback = async (code: string) => {
  const response = await apiInstancePublic.get<Response>("/auth/sso/callback", {
    params: {
      code,
    },
  });

  return response.data;
};
